import React from "react";

const PdfViewer = () => {
  const params = new URLSearchParams(window.location.search);

  console.log("params.get(");

  const fileUrl = params.get("file");
  const fileType = params.get("type");

  if (!fileUrl || !fileType) {
    return <p>Invalid file</p>;
  }

  return (
    <div className="w-[100vw] h-[100vh]">
      <embed src={fileUrl} type="application/pdf" className="w-full h-full" />
    </div>
  );
};

export default PdfViewer;
